// extracted by mini-css-extract-plugin
export default {"header":"CardHeader_header__tzEj9","placeholder":"CardHeader_placeholder__BE5fU"};